// extracted by mini-css-extract-plugin
export default {"popup-desig":"AgreementsListingPage_popup-desig__KOezr"};